import {
  Button,
  Container,
  DropdownMenuGroup,
  DropdownMenuItem,
  Icon,
  SearchBox,
  Text,
} from "@jds/core";
import JdsMenu from "../../UI/JdsMenu";
import { useState } from "react";

//css
import classes from "./EventStata.module.css";
import Accordion from "../components/Accordion/Accordion";

const EventStats = () => {
  const [state, setState] = useState("Tamil Nadu");
  const [city, setCity] = useState("Chennai");
  const [searchValue, setSearchValue] = useState("");
  const [selectedAcc, setSelectedAcc] = useState(null);

  const toggleItem = (index) => {
    if (index == selectedAcc) {
      setSelectedAcc(null);
    } else {
      setSelectedAcc(index);
    }
  };
  //state
  const StateLabel = (props) => (
    <div
      {...props}
      style={{ display: "flex", gap: "12px", alignItems: "center" }}
    >
      <Text text={state} appearance="heading_xs" />
      <Icon ic={"IcChevronDown"} />
    </div>
  );

  const handleState = (value) => {
    setState(value);
  };

  const stateList = [
    {
      label: "Tamil Nadu",
      value: "Tamil Nadu",
    },
    {
      label: "Andhra Pradesh",
      value: "Andhra Pradesh",
    },
    {
      label: "Assam",
      value: "Assam",
    },
    {
      label: "Bihar",
      value: "Bihar",
    },
    {
      label: "Maharashtra",
      value: "Maharashtra",
    },
  ];

  //city
  const CityLabel = (props) => (
    <div
      {...props}
      style={{ display: "flex", gap: "12px", alignItems: "center" }}
    >
      <Text text={city} appearance="heading_xs" />
      <Icon ic={"IcChevronDown"} />
    </div>
  );

  const handleCity = (value) => {
    setCity(value);
  };

  const cityList = [
    {
      label: "Chennai",
      value: "Chennai",
    },
    {
      label: "Madurai",
      value: "Madurai",
    },
    {
      label: "Coimbatore",
      value: "Coimbatore",
    },
    {
      label: "Tiruchirappalli",
      value: "Tiruchirappalli",
    },
    {
      label: "Salem",
      value: "Salem",
    },
    {
      label: "Tiruppur",
      value: "Tiruppur",
    },
  ];
  const accordion = [
    {
      title: "Anant and Radhika Wedding",
      mainCard: [
        {
          title: "Guests Invited",
          value: "8,386",
        },
        {
          title: "Albums Created",
          value: "15",
        },
        {
          title: "Photos Uploaded",
          value: "12,398",
        },
      ],
      subCard: [
        [
          {
            title: "Guests",
            icon: "IcGroup",
            value: [
              { title: "Guests Invited", value: "16,74,927" },
              { title: "Approved Guests", value: "6,38,982" },
              { title: "Denied Guests", value: "13,35,981" },
              { title: "Blocked Guests", value: "24,83,037" },
              { title: "Guests with profile image", value: "24,83,037" },
              { title: "Guests with full access", value: "24,83,037" },
              { title: "Guests with face access", value: "24,83,037" },
              { title: " Guests with download access", value: "24,83,037" },
            ],
          },
        ],
        [
          {
            title: "Events",
            icon: "IcCelebration",
            value: [
              { title: "Event edited", value: "3,486" },
              { title: "Event rescheduled", value: "898" },
            ],
          },
          {
            title: "Albums",
            icon: "IcGroup",
            value: [
              { title: "Albums created", value: "15" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
            ],
          },
        ],
        [
          {
            title: "Photos",
            icon: "IcPhoto",
            value: [
              { title: "Total Uploaded", value: "15323" },
              { title: "Uploaded by guests", value: "15323" },
              {
                title: "Uploaded by guests approved by organizer",
                value: "15323",
              },
              { title: "Faces Detected", value: "15323" },
            ],
          },
        ],
      ],
    },
    {
      title: "Sam Birthday",
      mainCard: [
        {
          title: "Guests Invited",
          value: "8,386",
        },
        {
          title: "Albums Created",
          value: "15",
        },
        {
          title: "Photos Uploaded",
          value: "12,398",
        },
      ],
      subCard: [
        [
          {
            title: "Guests",
            icon: "IcGroup",
            value: [
              { title: "Guests Invited", value: "16,74,927" },
              { title: "Approved Guests", value: "6,38,982" },
              { title: "Denied Guests", value: "13,35,981" },
              { title: "Blocked Guests", value: "24,83,037" },
              { title: "Guests with profile image", value: "24,83,037" },
              { title: "Guests with full access", value: "24,83,037" },
              { title: "Guests with face access", value: "24,83,037" },
              { title: " Guests with download access", value: "24,83,037" },
            ],
          },
        ],
        [
          {
            title: "Events",
            icon: "IcCelebration",
            value: [
              { title: "Event edited", value: "3,486" },
              { title: "Event rescheduled", value: "898" },
            ],
          },
          {
            title: "Albums",
            icon: "IcGroup",
            value: [
              { title: "Albums created", value: "15" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
            ],
          },
        ],
        [
          {
            title: "Photos",
            icon: "IcPhoto",
            value: [
              { title: "Total Uploaded", value: "15323" },
              { title: "Uploaded by guests", value: "15323" },
              {
                title: "Uploaded by guests approved by organizer",
                value: "15323",
              },
              { title: "Faces Detected", value: "15323" },
            ],
          },
        ],
      ],
    },
    {
      title: "School Reunion",
      mainCard: [
        {
          title: "Guests Invited",
          value: "8,386",
        },
        {
          title: "Albums Created",
          value: "15",
        },
        {
          title: "Photos Uploaded",
          value: "12,398",
        },
      ],
      subCard: [
        [
          {
            title: "Guests",
            icon: "IcGroup",
            value: [
              { title: "Guests Invited", value: "16,74,927" },
              { title: "Approved Guests", value: "6,38,982" },
              { title: "Denied Guests", value: "13,35,981" },
              { title: "Blocked Guests", value: "24,83,037" },
              { title: "Guests with profile image", value: "24,83,037" },
              { title: "Guests with full access", value: "24,83,037" },
              { title: "Guests with face access", value: "24,83,037" },
              { title: " Guests with download access", value: "24,83,037" },
            ],
          },
        ],
        [
          {
            title: "Events",
            icon: "IcCelebration",
            value: [
              { title: "Event edited", value: "3,486" },
              { title: "Event rescheduled", value: "898" },
            ],
          },
          {
            title: "Albums",
            icon: "IcGroup",
            value: [
              { title: "Albums created", value: "15" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
            ],
          },
        ],
        [
          {
            title: "Photos",
            icon: "IcPhoto",
            value: [
              { title: "Total Uploaded", value: "15323" },
              { title: "Uploaded by guests", value: "15323" },
              {
                title: "Uploaded by guests approved by organizer",
                value: "15323",
              },
              { title: "Faces Detected", value: "15323" },
            ],
          },
        ],
      ],
    },
    {
      title: "Sasi and Priya Wedding",
      mainCard: [
        {
          title: "Guests Invited",
          value: "8,386",
        },
        {
          title: "Albums Created",
          value: "15",
        },
        {
          title: "Photos Uploaded",
          value: "12,398",
        },
      ],
      subCard: [
        [
          {
            title: "Guests",
            icon: "IcGroup",
            value: [
              { title: "Guests Invited", value: "16,74,927" },
              { title: "Approved Guests", value: "6,38,982" },
              { title: "Denied Guests", value: "13,35,981" },
              { title: "Blocked Guests", value: "24,83,037" },
              { title: "Guests with profile image", value: "24,83,037" },
              { title: "Guests with full access", value: "24,83,037" },
              { title: "Guests with face access", value: "24,83,037" },
              { title: " Guests with download access", value: "24,83,037" },
            ],
          },
        ],
        [
          {
            title: "Events",
            icon: "IcCelebration",
            value: [
              { title: "Event edited", value: "3,486" },
              { title: "Event rescheduled", value: "898" },
            ],
          },
          {
            title: "Albums",
            icon: "IcGroup",
            value: [
              { title: "Albums created", value: "15" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
            ],
          },
        ],
        [
          {
            title: "Photos",
            icon: "IcPhoto",
            value: [
              { title: "Total Uploaded", value: "15323" },
              { title: "Uploaded by guests", value: "15323" },
              {
                title: "Uploaded by guests approved by organizer",
                value: "15323",
              },
              { title: "Faces Detected", value: "15323" },
            ],
          },
        ],
      ],
    },
    {
      title: "Saravanan Anni",
      mainCard: [
        {
          title: "Guests Invited",
          value: "8,386",
        },
        {
          title: "Albums Created",
          value: "15",
        },
        {
          title: "Photos Uploaded",
          value: "12,398",
        },
      ],
      subCard: [
        [
          {
            title: "Guests",
            icon: "IcGroup",
            value: [
              { title: "Guests Invited", value: "16,74,927" },
              { title: "Approved Guests", value: "6,38,982" },
              { title: "Denied Guests", value: "13,35,981" },
              { title: "Blocked Guests", value: "24,83,037" },
              { title: "Guests with profile image", value: "24,83,037" },
              { title: "Guests with full access", value: "24,83,037" },
              { title: "Guests with face access", value: "24,83,037" },
              { title: " Guests with download access", value: "24,83,037" },
            ],
          },
        ],
        [
          {
            title: "Events",
            icon: "IcCelebration",
            value: [
              { title: "Event edited", value: "3,486" },
              { title: "Event rescheduled", value: "898" },
            ],
          },
          {
            title: "Albums",
            icon: "IcGroup",
            value: [
              { title: "Albums created", value: "15" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
            ],
          },
        ],
        [
          {
            title: "Photos",
            icon: "IcPhoto",
            value: [
              { title: "Total Uploaded", value: "15323" },
              { title: "Uploaded by guests", value: "15323" },
              {
                title: "Uploaded by guests approved by organizer",
                value: "15323",
              },
              { title: "Faces Detected", value: "15323" },
            ],
          },
        ],
      ],
    },
    {
      title: "Sanjai and Radhika Wedding",
      mainCard: [
        {
          title: "Guests Invited",
          value: "8,386",
        },
        {
          title: "Albums Created",
          value: "15",
        },
        {
          title: "Photos Uploaded",
          value: "12,398",
        },
      ],
      subCard: [
        [
          {
            title: "Guests",
            icon: "IcGroup",
            value: [
              { title: "Guests Invited", value: "16,74,927" },
              { title: "Approved Guests", value: "6,38,982" },
              { title: "Denied Guests", value: "13,35,981" },
              { title: "Blocked Guests", value: "24,83,037" },
              { title: "Guests with profile image", value: "24,83,037" },
              { title: "Guests with full access", value: "24,83,037" },
              { title: "Guests with face access", value: "24,83,037" },
              { title: " Guests with download access", value: "24,83,037" },
            ],
          },
        ],
        [
          {
            title: "Events",
            icon: "IcCelebration",
            value: [
              { title: "Event edited", value: "3,486" },
              { title: "Event rescheduled", value: "898" },
            ],
          },
          {
            title: "Albums",
            icon: "IcGroup",
            value: [
              { title: "Albums created", value: "15" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
            ],
          },
        ],
        [
          {
            title: "Photos",
            icon: "IcPhoto",
            value: [
              { title: "Total Uploaded", value: "15323" },
              { title: "Uploaded by guests", value: "15323" },
              {
                title: "Uploaded by guests approved by organizer",
                value: "15323",
              },
              { title: "Faces Detected", value: "15323" },
            ],
          },
        ],
      ],
    },
    {
      title: "Naresh and Radhika Wedding",
      mainCard: [
        {
          title: "Guests Invited",
          value: "8,386",
        },
        {
          title: "Albums Created",
          value: "15",
        },
        {
          title: "Photos Uploaded",
          value: "12,398",
        },
      ],
      subCard: [
        [
          {
            title: "Guests",
            icon: "IcGroup",
            value: [
              { title: "Guests Invited", value: "16,74,927" },
              { title: "Approved Guests", value: "6,38,982" },
              { title: "Denied Guests", value: "13,35,981" },
              { title: "Blocked Guests", value: "24,83,037" },
              { title: "Guests with profile image", value: "24,83,037" },
              { title: "Guests with full access", value: "24,83,037" },
              { title: "Guests with face access", value: "24,83,037" },
              { title: " Guests with download access", value: "24,83,037" },
            ],
          },
        ],
        [
          {
            title: "Events",
            icon: "IcCelebration",
            value: [
              { title: "Event edited", value: "3,486" },
              { title: "Event rescheduled", value: "898" },
            ],
          },
          {
            title: "Albums",
            icon: "IcGroup",
            value: [
              { title: "Albums created", value: "15" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
            ],
          },
        ],
        [
          {
            title: "Photos",
            icon: "IcPhoto",
            value: [
              { title: "Total Uploaded", value: "15323" },
              { title: "Uploaded by guests", value: "15323" },
              {
                title: "Uploaded by guests approved by organizer",
                value: "15323",
              },
              { title: "Faces Detected", value: "15323" },
            ],
          },
        ],
      ],
    },
    {
      title: "Hentry and Radhika Wedding",
      mainCard: [
        {
          title: "Guests Invited",
          value: "8,386",
        },
        {
          title: "Albums Created",
          value: "15",
        },
        {
          title: "Photos Uploaded",
          value: "12,398",
        },
      ],
      subCard: [
        [
          {
            title: "Guests",
            icon: "IcGroup",
            value: [
              { title: "Guests Invited", value: "16,74,927" },
              { title: "Approved Guests", value: "6,38,982" },
              { title: "Denied Guests", value: "13,35,981" },
              { title: "Blocked Guests", value: "24,83,037" },
              { title: "Guests with profile image", value: "24,83,037" },
              { title: "Guests with full access", value: "24,83,037" },
              { title: "Guests with face access", value: "24,83,037" },
              { title: " Guests with download access", value: "24,83,037" },
            ],
          },
        ],
        [
          {
            title: "Events",
            icon: "IcCelebration",
            value: [
              { title: "Event edited", value: "3,486" },
              { title: "Event rescheduled", value: "898" },
            ],
          },
          {
            title: "Albums",
            icon: "IcGroup",
            value: [
              { title: "Albums created", value: "15" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
              { title: "Albums1", value: "15323" },
            ],
          },
        ],
        [
          {
            title: "Photos",
            icon: "IcPhoto",
            value: [
              { title: "Total Uploaded", value: "15323" },
              { title: "Uploaded by guests", value: "15323" },
              {
                title: "Uploaded by guests approved by organizer",
                value: "15323",
              },
              { title: "Faces Detected", value: "15323" },
            ],
          },
        ],
      ],
    },
  ];
  const FilterBtn = (props) => (
    <Button
      iconLeft={"IcFilterMultiple"}
      label="Filter"
      kind="secondary"
      size="small"
      {...props}
    />
  );
  return (
    <div>
      <Container style={{ marginTop: "24px" }} fullWidth>
        <Container
          fullWidth
          horizontalAlign={"space-between"}
          verticalAlign="center"
        >
          <Container fullWidth gap={60}>
            <JdsMenu trigger={{ component: StateLabel }} onSelect={handleState}>
              <DropdownMenuGroup hideBottomDivider>
                {stateList?.map((item, i) => (
                  <DropdownMenuItem value={item.value} label={item.label} />
                ))}
              </DropdownMenuGroup>
            </JdsMenu>
            <JdsMenu trigger={{ component: CityLabel }} onSelect={handleCity}>
              <DropdownMenuGroup hideBottomDivider>
                {cityList?.map((item, i) => (
                  <DropdownMenuItem value={item.value} label={item.label} />
                ))}
              </DropdownMenuGroup>
            </JdsMenu>
          </Container>

          <Container
            direction="row"
            verticalAlign="center"
            gap={16}
            style={{ width: "550px" }}
          >
            <SearchBox
              value={searchValue}
              label="Search Events"
              prefix="IcSearch"
            />
            <JdsMenu
              trigger={{ component: FilterBtn }}
              onSelect={(value) => {}}
            >
              <DropdownMenuGroup hideBottomDivider>
                {/* <DropdownMenuItem
                  value="ALL"
                  prefix={"IcProfile"}
                  label="All Guests"
                /> */}
              </DropdownMenuGroup>
            </JdsMenu>
          </Container>
        </Container>
      </Container>
      <Text
        text="Event - 08"
        color="primary_grey_80"
        appearance="body-s-bold"
      />
      {accordion?.map((item, index) => (
        <Accordion
          toggleItem={() => toggleItem(index)}
          show={index == selectedAcc ? true : false}
          data={item}
        />
      ))}
    </div>
  );
};

export default EventStats;
